import { render, staticRenderFns } from "./ManageClasses.vue?vue&type=template&id=283d9f7a"
import script from "./ManageClasses.vue?vue&type=script&lang=js"
export * from "./ManageClasses.vue?vue&type=script&lang=js"
import style0 from "./ManageClasses.vue?vue&type=style&index=0&id=283d9f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports